"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HeartOnHand = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HeartOnHand = function HeartOnHand(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.983 6.541l.01-.01.007.008.008-.008.01.01s2.264-1.905 3.12-3.221c.58-.892.736-1.991 0-2.75a1.844 1.844 0 00-2.665 0l-.465.481L8 1.043l-.007.008-.466-.482a1.844 1.844 0 00-2.665 0c-.736.76-.58 1.859 0 2.75.856 1.317 3.121 3.222 3.121 3.222zm7.827.531l-3.378 4.506c-.166.22-.405.367-.675.414l-5.833 1.03-.275.274.468.468-2.235 2.235L0 12.12l2.236-2.236.468.468 1.938-1.938c.343-.343.8-.532 1.286-.532h5.14c.31 0 .564.252.564.562 0 .29-.227.537-.517.56L7.562 9.3l.067.796 3.552-.296a1.37 1.37 0 001.25-1.357c0-.132-.018-.26-.054-.38l1.955-2.2a.946.946 0 01.686-.32.944.944 0 01.704.28.96.96 0 01.088 1.25z",
    fill: "currentColor"
  }));
};

exports.HeartOnHand = HeartOnHand;
var _default = HeartOnHand;
exports.default = _default;